(function (yourcode) {
    // The global jQuery object is passed as a parameter
    yourcode(window.jQuery, window, document);
})(function ($, window, document) {
    // DOC ready
    $(function () {
        /* Indicator */
        $(window).scroll(function () {
            var wintop = $(window).scrollTop();
            var docheight = $(document).height();
            var winheight = $(window).height();
            var scrolled = (wintop / (docheight - winheight)) * 100;

            $('.scroll_line').css('width', scrolled + '%');
        });
        /* Indicator END */

        /* Slick Slider for References */
        $('.reference-slide').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            prevArrow: '',
            nextArrow: '',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
        });
        /* Slick Slider for References END */

        /* Scroll */
        $('.main-navbar__menu-list .menu-item a, .hdolg__stepitem, .footer__back_to_top').click(function (e) {
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') ||
                location.hostname == this.hostname
            ) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

                if (target.length && !$.scrollify.isDisabled()) {
                    $('html,body')
                        .stop()
                        .animate(
                            {
                                scrollTop: target.offset().top - 70, //offsets for fixed header
                            },
                            'linear',
                        );
                }
            }
        });

        $('.page-template-linkepites_page-php .main-navbar__menu-list .menu-item a').click(function (event) {
            event.preventDefault();
            $('html, body').animate({ scrollTop: $($(this).attr('href')).offset().top }, 500);
        });

        $('.home #menu-item-388 a').click(function (event) {
            $('html, body').animate({ scrollTop: $($(this).attr('href')).offset().top }, 500);
        });

        /* Scroll END */

        /* Scrollify */
        if (window.location.pathname == '/') {
            (function () {
                var SNAP_DISTANCE = 150; // px - only snap if the user stopped within this range of a section edge
                var HEADER_OFFSET = 50; // px - fixed header height
                var DURATION = 250; // ms - snap animation length
                var SETTLE_DELAY_SLOW = 150; // ms of no scroll movement before a gentle scroll is considered "stopped"
                var SETTLE_DELAY_FAST = 400; // ms - give a fast scroll/fling more time to fully play out before we check
                var FAST_SPEED = 2; // px/ms - scroll speed above this is treated as "fast"

                // native scroll the whole time (no preventDefault, no live interception) - we only
                // nudge to the nearest section once scrolling has actually settled, and only when
                // already close to it, so it can't fight the browser and can't feel aggressive
                var $sections = $('.home_section');
                var snapping = false;
                var settleTimer;
                var lastY = window.pageYOffset;
                var lastT = null;
                var lastSpeed = 0;

                if (!$sections.length) {
                    return;
                }

                function sectionTops() {
                    return $sections
                        .map(function () {
                            return Math.round($(this).offset().top) - HEADER_OFFSET;
                        })
                        .get();
                }

                function nearest(scrollTop, tops) {
                    var closest = tops[0];
                    var minDiff = Math.abs(tops[0] - scrollTop);

                    for (var i = 1; i < tops.length; i++) {
                        var diff = Math.abs(tops[i] - scrollTop);
                        if (diff < minDiff) {
                            minDiff = diff;
                            closest = tops[i];
                        }
                    }
                    return { top: closest, diff: minDiff };
                }

                function easeOutQuad(t) {
                    return t * (2 - t);
                }

                function snapTo(target) {
                    var startY = window.pageYOffset;
                    var change = target - startY;
                    var startTime = null;

                    if (!change) {
                        return;
                    }

                    snapping = true;

                    function step(timestamp) {
                        if (startTime === null) {
                            startTime = timestamp;
                        }
                        var progress = Math.min((timestamp - startTime) / DURATION, 1);

                        window.scrollTo(0, startY + change * easeOutQuad(progress));

                        if (progress < 1) {
                            requestAnimationFrame(step);
                        } else {
                            snapping = false;
                        }
                    }
                    requestAnimationFrame(step);
                }

                $(window).on('scroll', function () {
                    if (snapping) {
                        return;
                    }

                    // measure how fast the user is scrolling right now, so a fast fling gets more
                    // time to fully play out before we step in - stops us from cutting off/fighting
                    // a fast scroll the way a short, fixed delay would
                    var now = window.performance ? performance.now() : Date.now();
                    var y = window.pageYOffset;
                    if (lastT !== null && now > lastT) {
                        lastSpeed = Math.abs(y - lastY) / (now - lastT);
                    }
                    lastY = y;
                    lastT = now;

                    clearTimeout(settleTimer);
                    settleTimer = setTimeout(
                        function () {
                            var result = nearest(window.pageYOffset, sectionTops());
                            if (result.diff > 0 && result.diff <= SNAP_DISTANCE) {
                                snapTo(result.top);
                            }
                        },
                        lastSpeed > FAST_SPEED ? SETTLE_DELAY_FAST : SETTLE_DELAY_SLOW,
                    );
                });
            })();
        }
        /* Scrollify END */

        /* AOS Animate  START */
        var windowSize = screen.width;
        if (windowSize >= 991) {
            AOS.init({
                easing: 'ease-in-out-sine',
            });
        }
        /* AOS Animate END */

        /* Back to top button opacity */
        window.onscroll = function () {
            scrollFunction();
        };

        function scrollFunction() {
            var fiftyvh = window.innerHeight / 2;

            if (document.body.scrollTop > fiftyvh || document.documentElement.scrollTop > fiftyvh) {
                document.getElementById('back_to_top').style.opacity = '1';
            } else {
                document.getElementById('back_to_top').style.opacity = '0';
            }
        }

        // When the user clicks on the button, scroll to the top of the document
        function topFunction() {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        }
        /* Back to top button opacity END */

        /* Animation effect */
        // Add smooth scrolling to all links
        if (!window.location.origin) {
            // For IE
            window.location.origin =
                window.location.protocol + '//' + (window.location.port ? ':' + window.location.port : '');
        }
        var url = window.location.origin + window.location.pathname;
        var homep = document.location.origin + '/';

        if (url == homep) {
            $(window).scroll(function () {
                var wScroll = $(this).scrollTop();
            });
        }

        $('.linkepites_click').click(function () {
            $('.linkepites_column_content').slideToggle();
            if ($('.linkepites_click span').hasClass('minus-icon')) {
                $('.linkepites_click span').removeClass('minus-icon');
                $('.linkepites_click span').addClass('plus-icon');
            } else {
                $('.linkepites_click span').addClass('minus-icon');
            }
            return false;
        });
        $('.linkfarm_click').click(function () {
            $('.linkfarm_column_content').slideToggle();
            if ($('.linkfarm_click span').hasClass('minus-icon')) {
                $('.linkfarm_click span').removeClass('minus-icon');
                $('.linkfarm_click span').addClass('plus-icon');
            } else {
                $('.linkfarm_click span').addClass('minus-icon');
            }
            return false;
        });
        $('.linkpremium_click').click(function () {
            $('.linkpremium_column_content').slideToggle();
            if ($('.linkpremium_click span').hasClass('minus-icon')) {
                $('.linkpremium_click span').removeClass('minus-icon');
                $('.linkpremium_click span').addClass('plus-icon');
            } else {
                $('.linkpremium_click span').addClass('minus-icon');
            }
            return false;
        });

        // webshop seo moblie - start
        if ($('tbody').hasClass('active_tab')) {
            $('.active_tab .webshopseo_column_content').slideToggle();

            if ($('.active_tab .webshopseo_click span').hasClass('minus-icon')) {
                $('.active_tab .webshopseo_click span').removeClass('minus-icon');
                $('.active_tab .webshopseo_click span').addClass('plus-icon');
            } else {
                $('.active_tab .webshopseo_click span').addClass('minus-icon');
            }
        }
        $('.webshopseo_click').click(function () {
            $('.webshopseo_column > tbody').removeClass('active_tab');
            $(this).parent().parent().addClass('active_tab');
            $('.active_tab .webshopseo_column_content').slideToggle();

            if ($('.active_tab .webshopseo_click span').hasClass('minus-icon')) {
                $('.active_tab .webshopseo_click span').removeClass('minus-icon');
                $('.active_tab .webshopseo_click span').addClass('plus-icon');
            } else {
                $('.active_tab .webshopseo_click span').addClass('minus-icon');
            }
        });
        // webshop seo moblie - end

        var div_pag = $('div.gyik_pagination');
        var div_gyik = $('#gyik');

        function showQuestions(num) {
            //hide all
            $('#gyik')
                .children('.block')
                .each(function () {
                    $(this).hide();
                });

            // Show only the first 4 child
            for (var i = num * 4; i < num * 4 + 4; i++) {
                $($('#gyik').children('.block')[i]).show();
            }

            //Remove current
            $(div_pag.children('.current')[0]).removeClass('current');

            // Add current
            $(div_pag.children()[num]).addClass('current');
        }

        if (div_pag) {
            var numQuestion = $('#gyik').children('.block').length;

            //hide all
            $('#gyik')
                .children('.block')
                .each(function () {
                    $(this).hide();
                });

            // Show only the first 4 child
            for (var i = 0; i < 4; i++) {
                $($('#gyik').children('.block')[i]).show();
            }

            //Make pagination
            for (var i = 0; i < numQuestion / 4; i++) {
                var pagItem = $("<a class='page-numbers'>" + (i + 1) + '</a>');
                pagItem.on('click', function () {
                    showQuestions($(this).text() - 1);
                });
                div_pag.append(pagItem);
            }

            if (numQuestion / 4 <= 1) {
                $('.gyik_pagination .page-numbers').css('display', 'none');
            }

            $(div_pag.children()[0]).addClass('current');
        }

        // auto fill 'link' input - START
        if ($('#Project_Linkajanloertekesito_1319').length == 1) {
            $('#Project_Linkajanloertekesito_1319').val(window.location.href);
        }
        // auto fill 'link' input - END

        // sticky tartalomjegyzék - linképítés aloldal -- START
        if ($('.linkepites_aloldal__tartalomjegyzek')[0]) {
            var topLimit = $('.linkepites_aloldal__tartalomjegyzek').offset().top - 80;

            $(window).scroll(function () {
                if (topLimit <= $(window).scrollTop()) {
                    if (
                        $('.post-template-default.single.single-post .linkepites_aloldal__tartalomjegyzek').length ||
                        $('.page-template-linkepites_page .linkepites_aloldal__tartalomjegyzek').length ||
                        $('.page-template-default.page .linkepites_aloldal__tartalomjegyzek').length
                    ) {
                        if (
                            topLimit + $('.blog_single__content').height() - 520 <= $(window).scrollTop() ||
                            topLimit + $('.page_content').height() - 630 <= $(window).scrollTop() ||
                            topLimit + $('.other_page').height() - 740 <= $(window).scrollTop()
                        ) {
                            $('.linkepites_aloldal__tartalomjegyzek').removeClass('stickIt');
                            $('.linkepites_aloldal__tartalomjegyzek')
                                .css('position', 'absoulte')
                                .css('top', $('body').height() - 1520 + 'px');
                        } else {
                            $('.linkepites_aloldal__tartalomjegyzek').css('position', 'absoulte').css('top', '');
                            $('.linkepites_aloldal__tartalomjegyzek').addClass('stickIt');
                        }
                    }
                } else {
                    $('.linkepites_aloldal__tartalomjegyzek').removeClass('stickIt');
                }
            });
        }
        // sticky tartalomjegyzék - linképítés aloldal -- END

        $('.linkepites_aloldal__tartalomjegyzek a').click(function () {
            $('.linkepites_aloldal__tartalomjegyzek a').removeClass('linkepites_aloldal__tartalomjegyzek__active');
            $(this).addClass('linkepites_aloldal__tartalomjegyzek__active');
        });

        /* Tartalomkegyzék -> custom id -> h3 START */
        $(document).ready(function () {
            var $num = 0;
            jQuery.each(
                $(
                    '.linkepites_aloldal__content h3, .linkepites_aloldal__content h2, .blog_single__content h3, .blog_single__content h2, .other_page h3, .other_page h2',
                ),
                function () {
                    $(this).attr('id', 'tartalomjegyzek__0' + $num++);
                },
            );
        });

        /* Tartalomkegyzék -> custom id ->h2 END */

        /* tartalomjegyzek -> under the content (mobile) START */
        var windowWidth = $(window).width();
        var construma = $('.page-template-linkepites_page .linkepites_aloldal__tartalomjegyzek');
        var post = $('.post-template-default.single .linkepites_aloldal__tartalomjegyzek');
        var page = $('.other_page .linkepites_aloldal__tartalomjegyzek');

        //only construma page
        if (construma.length) {
            if (windowWidth < 885) {
                $('.linkepites_aloldal__tartalomjegyzek').clone().prependTo('.bottom_tartalomjegyzek');
                $('.col-tartalomjegyzek').remove('.linkepites_aloldal__tartalomjegyzek');

                $('.linkepites_aloldal__tartalomjegyzek a').click(function () {
                    $('.bottom_tartalomjegyzek_title').trigger('click');
                });
            }
            //only post page
        } else if (post.length) {
            if (windowWidth < 1090) {
                $('.linkepites_aloldal__tartalomjegyzek').clone().prependTo('.bottom_tartalomjegyzek');
                $('.col-tartalomjegyzek').remove('.linkepites_aloldal__tartalomjegyzek');

                $('.linkepites_aloldal__tartalomjegyzek a').click(function () {
                    $('.bottom_tartalomjegyzek_title').trigger('click');
                });
            }
        } else if (page.length) {
            if (windowWidth < 1090) {
                $('.linkepites_aloldal__tartalomjegyzek').clone().prependTo('.bottom_tartalomjegyzek');
                $('.col-tartalomjegyzek').remove('.linkepites_aloldal__tartalomjegyzek');

                $('.linkepites_aloldal__tartalomjegyzek a').click(function () {
                    $('.bottom_tartalomjegyzek_title').trigger('click');
                });
            }
        }

        /* close button to bottom tartalomjegyzek  for all tartalomjegyzek pages  START */
        $('.bottom_tartalomjegyzek_title').click(function () {
            $('.bottom_tartalomjegyzek').slideToggle();
            // alert($('.bottom_tartalomjegyzek_title.close_bottom_tartalomjegyzek')[0]);
            if ($('.close_bottom_tartalomjegyzek')[0]) {
                $(this).removeClass('close_bottom_tartalomjegyzek');
            } else {
                $(this).addClass('close_bottom_tartalomjegyzek');
            }
        });
        /* close button to bottom tartalomjegyzek  for all tartalomjegyzek pages  END */

        /* tartalomjegyzek -> under the content (mobile) END */

        /* tartalomjegyzek scrolling by click  START*/

        if ($('.linkepites_aloldal__tartalomjegyzek')[0]) {
            $('.linkepites_aloldal__tartalomjegyzek a').click(function (e) {
                if (
                    location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') ||
                    location.hostname == this.hostname
                ) {
                    var target = $(this.hash);
                    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

                    if (target.length) {
                        $('html,body')
                            .stop()
                            .animate(
                                {
                                    scrollTop: target.offset().top - 70, //offsets for fixed header
                                },
                                'linear',
                            );
                    }
                }
            });
        }

        /* tartalomjegyzek scrolling by click END */

        /* highlighted title->tartalomjegyzek (scrolling content) START */

        $(window).on('scroll', function () {
            var scrolled = $(this).scrollTop();

            $(
                '.linkepites_aloldal__content h2, .blog_single__content h2, .other_page h2, .linkepites_aloldal__content h3, .blog_single__content h3, .other_page h3',
            ).filter(function () {
                if (scrolled >= $(this).offset().top - 150 && scrolled <= $(this).offset().top) {
                    var idName = $(this).attr('id');
                    var idName_number = idName.substring(18, 20);

                    if (idName_number == 0) {
                        $('.linkepites_aloldal__tartalomjegyzek__title:first-child a').css('color', '#1cade5');
                    } else {
                        $('.linkepites_aloldal__tartalomjegyzek__title:first-child a').css('color', '#fff');
                    }

                    $('.linkepites_aloldal__tartalomjegyzek__title a').removeClass(
                        'linkepites_aloldal__tartalomjegyzek__active',
                    );
                    $('.linkepites_aloldal__tartalomjegyzek__subtitle a').removeClass(
                        'linkepites_aloldal__tartalomjegyzek__active',
                    );
                    $('.linkepites_aloldal__tartalomjegyzek__title').removeAttr('id');
                    $('.linkepites_aloldal__tartalomjegyzek__subtitle').removeAttr('id');

                    return $('.linkepites_aloldal__tartalomjegyzek__title_' + idName_number).attr(
                        'id',
                        'linkepites_aloldal__tartalomjegyzek__title__active',
                    );
                } else {
                    return $('.linkepites_aloldal__tartalomjegyzek__title_' + idName_number).removeAttr('id');
                }
            });

            /* highlighted title->tartalomjegyzek (scrolling content) END */

            /* Tartalomjegyzek auto scroll  START */

            var act = $('#linkepites_aloldal__tartalomjegyzek__title__active');

            if (act.length) {
                lastClassName = $('.linkepites_aloldal__tartalomjegyzek li:last-child').attr('class').split(' ')[1];
                var lastClassNum = lastClassName.substring(43, 45);

                var secondLastNum = lastClassNum - 1;

                var last = $(
                    '#linkepites_aloldal__tartalomjegyzek__title__active.linkepites_aloldal__tartalomjegyzek__title_' +
                        secondLastNum,
                );
                var last1 = $(
                    '#linkepites_aloldal__tartalomjegyzek__title__active.linkepites_aloldal__tartalomjegyzek__title_' +
                        lastClassNum,
                );

                if (last.length || last1.length) {
                } else if (
                    scrolled - 200 <= $('.blog_single__content').height() ||
                    scrolled - 200 <= $('.page_content').height()
                ) {
                    var class_title_name_for_scroll = $('#linkepites_aloldal__tartalomjegyzek__title__active')
                        .attr('class')
                        .split(' ')[1];
                    var class_title_name_for_scroll_num = class_title_name_for_scroll.substring(43, 45);

                    if (class_title_name_for_scroll_num <= 2) {
                        class_title_name_for_scroll_num = 0;
                        $('.linkepites_aloldal__tartalomjegyzek__title_' + class_title_name_for_scroll_num).attr(
                            'id',
                            'scrolltop',
                        );

                        document.getElementById('scrolltop').scrollIntoView({
                            block: 'start',
                            behavior: 'smooth',
                        });
                    } else {
                        class_title_name_for_scroll_num = class_title_name_for_scroll_num - 2;
                        $('.linkepites_aloldal__tartalomjegyzek__title_' + class_title_name_for_scroll_num).attr(
                            'id',
                            'scrolltop',
                        );

                        document.getElementById('scrolltop').scrollIntoView({
                            block: 'start',
                            behavior: 'smooth',
                        });
                    }
                }
            }

            /* Tartalomjegyzek auto scroll  END */
        });

        /* Auditor page timeline START */

        // mobile
        var windowSize = screen.width; //$(window).width();
        if (windowSize <= 991) {
            var img_height = $('.main_history__content__img img.active_history_content').height();

            $('.main_history__content__img').css('height', img_height + 'px');
        }
        // desktop / mobile
        $('.main_history__timeline__itmes li a').on('click', function () {
            $('.main_history__timeline__itmes li a').removeClass('active_timeline_item');
            $(this).addClass('active_timeline_item');

            get_year = $(this).text();
            $('div').removeClass('active_history_content');
            $('img').removeClass('active_history_content');
            $('img')
                .find("[data-year='" + get_year + "']")
                .addClass('active_history_content');
            $('div')
                .find("[data-year='" + get_year + "']")
                .addClass('active_history_content');

            // $(".main_history__content").attr('data-year');

            if (windowSize <= 575) {
                var img_height = $('.main_history__content__img img.active_history_content').height();

                $('.main_history__content__img').css('height', img_height + 'px');

                $([document.documentElement, document.body]).animate(
                    {
                        scrollTop: $('div.active_history_content').offset().top - 50,
                    },
                    1800,
                );
            }
        });
        /* Auditor page timeline END */

        /**/
        $(function () {
            $('.rotating-slider').rotatingSlider();
        });

        //default pagination name
        var default_next_name = $('.previous-slide .press_release__boxes__references').text();
        $('.slider_circle_design__outside__prev_ref a').empty().append(default_next_name);

        var default_prev_name = $('.next-slide .press_release__boxes__references').text();
        $('.slider_circle_design__outside__next_ref a').empty().append(default_prev_name);

        var $default_slide_url = $('.rotating-slider .active-slide .inner').attr('data-press_rel_url');
        $('.press_release__boxes__button').attr('href', $default_slide_url);

        var break_off = 0;

        $(document).ready(function () {
            //prev button on circle - slider
            $('.slider_circle_design__outside__prev_ref a').click(function () {
                $('.left-arrow button')[0].click();

                // add url to button
                $slide_url = $('.rotating-slider .active-slide .inner').attr('data-press_rel_url');
                // alert($slide_url);
                $('.press_release__boxes__button').attr('href', $slide_url);

                $(this)
                    .css('left', '120px')
                    .css('right', 'unset')
                    .css('opacity', '0')
                    .css('transition', 'all 0.4s ease 0s');
                var prev_name = $('.previous-slide .press_release__boxes__references').text();

                $('.slider_circle_design__outside__next_ref a')
                    .css('left', '120px')
                    .css('right', 'unset')
                    .css('opacity', '0')
                    .css('transition', 'all 0.4s ease 0s');
                var next_name = $('.next-slide .press_release__boxes__references').text();

                setTimeout(
                    function () {
                        $(this).empty().append(prev_name);
                        $('.slider_circle_design__outside__next_ref a').empty().append(next_name);
                        $(this).css('left', 0).css('right', 'unset').css('transition', 'unset').css('opacity', '1');
                        $('.slider_circle_design__outside__next_ref a')
                            .css('left', 0)
                            .css('right', 'unset')
                            .css('transition', 'unset')
                            .css('opacity', '1');
                    }.bind(this),
                    500,
                );
            });

            //next button on circle - slider
            $('.slider_circle_design__outside__next_ref a').click(function () {
                // break_off = 1;
                $('.right-arrow button')[0].click();

                // add url to button
                $slide_url = $('.rotating-slider .active-slide .inner').attr('data-press_rel_url');
                // alert($slide_url);
                $('.press_release__boxes__button').attr('href', $slide_url);

                $(this)
                    .css('right', '120px')
                    .css('left', 'unset')
                    .css('opacity', '0')
                    .css('transition', 'all 0.4s ease 0s');
                var next_name = $('.next-slide .press_release__boxes__references').text();

                $('.slider_circle_design__outside__prev_ref a')
                    .css('right', '120px')
                    .css('left', 'unset')
                    .css('opacity', '0')
                    .css('transition', 'all 0.4s ease 0s');
                var prev_name = $('.previous-slide .press_release__boxes__references').text();

                setTimeout(
                    function () {
                        $(this).empty().append(next_name);
                        $('.slider_circle_design__outside__prev_ref a').empty().append(prev_name);
                        $(this).css('right', 0).css('left', 'unset').css('transition', 'unset').css('opacity', '1');
                        $('.slider_circle_design__outside__prev_ref a')
                            .css('right', 0)
                            .css('left', 'unset')
                            .css('transition', 'unset')
                            .css('opacity', '1');
                    }.bind(this),
                    500,
                );
            });
        });

        $('.slider_circle_design__outside__next_ref a, .slider_circle_design__outside__prev_ref a').hover(function (e) {
            var isClicked = $(this).data('clicked', 'yes');
            if (isClicked) {
                break_off = 1;
            }
        });

        // press release slider -> autoslide in 5 seconds
        if ($('.slider_circle_design__outside__next_ref').length) {
            window.setInterval(event, 11000);
            function event() {
                if (break_off != 0) {
                } else {
                    $('.slider_circle_design__outside__next_ref a').click();
                }
            }
        }

        /**
         *
         * Cookie Settings
         *
         */

        function getCookie(cname) {
            var name = cname + '=';
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return '';
        }

        $("input[type='radio'][name='LeadLandingValasz']").change(function () {
            if ($('#LeadLanding').length) {
                $('#LeadLanding').val(this.value);
            }
        });

        // Google Recaptcha Form Validation
        $('form.captcha-validaiton').submit(function (event) {
            if (grecaptcha.enterprise.getResponse() === '') {
                event.preventDefault();
                $(this).find('.error-msg').text('Kérlek pipáld ki, hogy nem vagy robot!');
            }
        });
    });
    // DOC ready END
    // IIFE continues
});
